(function () {
  'use strict';

  function getCategoryOptions(categorySelect) {
    return Array.from(categorySelect.options)
      .filter(function (option) {
        return option.value;
      })
      .map(function (option) {
        var subOptions = (option.dataset.options || '')
          .split(',')
          .map(function (item) {
            return item.trim();
          })
          .filter(Boolean);

        return {
          label: option.value,
          subOptions: subOptions
        };
      });
  }

  function initSelect(wrapper) {
    var nativeSelect = wrapper.querySelector('select');
    if (!nativeSelect) {
      return null;
    }

    if (nativeSelect.dataset.tdContactReady === 'true') {
      return {
        close: function () {
          wrapper.classList.remove('is-open');
          var existingTrigger = wrapper.querySelector('[data-td-contact-trigger]');
          if (existingTrigger) {
            existingTrigger.setAttribute('aria-expanded', 'false');
          }
        },
        sync: function () {
          var selectedOption = nativeSelect.options[nativeSelect.selectedIndex];
          var placeholder = nativeSelect.dataset.placeholder || '';
          var valueEl = wrapper.querySelector('[data-td-contact-value]');
          var label = selectedOption && selectedOption.value ? selectedOption.textContent : placeholder;
          if (valueEl) {
            valueEl.textContent = label;
          }
          wrapper.classList.toggle('is-filled', Boolean(selectedOption && selectedOption.value));
          wrapper.classList.toggle('is-disabled', nativeSelect.disabled);
        }
      };
    }

    nativeSelect.dataset.tdContactReady = 'true';
    nativeSelect.classList.add('td-contact__select-native');

    var trigger = wrapper.querySelector('[data-td-contact-trigger]');
    var valueEl = wrapper.querySelector('[data-td-contact-value]');
    var list = wrapper.querySelector('[data-td-contact-list]');
    var placeholder = nativeSelect.dataset.placeholder || '';

    function syncTrigger() {
      var selectedOption = nativeSelect.options[nativeSelect.selectedIndex];
      var label = selectedOption && selectedOption.value ? selectedOption.textContent : placeholder;
      valueEl.textContent = label;
      wrapper.classList.toggle('is-filled', Boolean(selectedOption && selectedOption.value));
      wrapper.classList.toggle('is-disabled', nativeSelect.disabled);

      if (list) {
        list.querySelectorAll('[data-td-contact-option]').forEach(function (item) {
          item.classList.toggle('is-selected', item.dataset.value === nativeSelect.value);
        });
      }
    }

    function closeList() {
      wrapper.classList.remove('is-open');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    }

    function openList() {
      if (nativeSelect.disabled) {
        return;
      }

      document.querySelectorAll('[data-td-contact-select].is-open').forEach(function (other) {
        if (other !== wrapper) {
          other.classList.remove('is-open');
          var otherTrigger = other.querySelector('[data-td-contact-trigger]');
          if (otherTrigger) {
            otherTrigger.setAttribute('aria-expanded', 'false');
          }
        }
      });

      wrapper.classList.add('is-open');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      }
    }

    function setValue(value) {
      nativeSelect.value = value;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      syncTrigger();
      closeList();
    }

    if (trigger) {
      trigger.addEventListener('click', function () {
        if (wrapper.classList.contains('is-open')) {
          closeList();
        } else {
          openList();
        }
      });
    }

    if (list) {
      list.addEventListener('click', function (event) {
        var option = event.target.closest('[data-td-contact-option]');
        if (!option || option.classList.contains('is-placeholder')) {
          return;
        }

        setValue(option.dataset.value || '');
      });
    }

    nativeSelect.addEventListener('change', syncTrigger);
    syncTrigger();

    return {
      close: closeList,
      sync: syncTrigger
    };
  }

  function initDependentDropdown(form, categorySelect, topicSelect) {
    var categoryOptions = getCategoryOptions(categorySelect);
    var topicWrapper = form.querySelector('[data-td-contact-select-for="' + topicSelect.id + '"]');
    var topicList = topicWrapper ? topicWrapper.querySelector('[data-td-contact-list]') : null;

    function rebuildTopicOptions(categoryValue) {
      var match = categoryOptions.find(function (option) {
        return option.label === categoryValue;
      });

      topicSelect.innerHTML = '';
      topicList.innerHTML = '';

      var placeholderOption = document.createElement('option');
      placeholderOption.value = '';
      placeholderOption.textContent = topicSelect.dataset.placeholder || '';
      topicSelect.appendChild(placeholderOption);

      var placeholderItem = document.createElement('li');
      placeholderItem.className = 'td-contact__select-option is-placeholder';
      placeholderItem.setAttribute('role', 'option');
      placeholderItem.setAttribute('data-td-contact-option', '');
      placeholderItem.dataset.value = '';
      placeholderItem.textContent = topicSelect.dataset.placeholder || '';
      topicList.appendChild(placeholderItem);

      if (match && match.subOptions.length) {
        match.subOptions.forEach(function (subOption) {
          var option = document.createElement('option');
          option.value = subOption;
          option.textContent = subOption;
          topicSelect.appendChild(option);

          var item = document.createElement('li');
          item.className = 'td-contact__select-option';
          item.setAttribute('role', 'option');
          item.setAttribute('data-td-contact-option', '');
          item.dataset.value = subOption;
          item.textContent = subOption;
          topicList.appendChild(item);
        });

        topicSelect.disabled = false;
      } else {
        topicSelect.disabled = true;
      }

      var topicControl = initSelect(topicWrapper);
      if (topicControl) {
        topicControl.sync();
      }

      if (topicWrapper) {
        topicWrapper.classList.toggle('is-disabled', topicSelect.disabled);
      }
    }

    categorySelect.addEventListener('change', function () {
      categoryOptions = getCategoryOptions(categorySelect);
      rebuildTopicOptions(categorySelect.value);
    });

    rebuildTopicOptions(categorySelect.value);
  }

  function initForm(form) {
    var selects = form.querySelectorAll('[data-td-contact-select]');

    selects.forEach(function (wrapper) {
      initSelect(wrapper);
    });

    var categorySelect = form.querySelector('#ContactForm-related_to');
    var topicSelect = form.querySelector('#ContactForm-related_to_subject');

    if (categorySelect && topicSelect) {
      initDependentDropdown(form, categorySelect, topicSelect);
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-td-contact-select]')) {
        document.querySelectorAll('[data-td-contact-select].is-open').forEach(function (wrapper) {
          wrapper.classList.remove('is-open');
          var trigger = wrapper.querySelector('[data-td-contact-trigger]');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        document.querySelectorAll('[data-td-contact-select].is-open').forEach(function (wrapper) {
          wrapper.classList.remove('is-open');
          var trigger = wrapper.querySelector('[data-td-contact-trigger]');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });
  }

  document.querySelectorAll('[data-td-contact-form]').forEach(initForm);
})();
